import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { DeviceWithoutLegacyPassword } from "../../../../generated/types";
import { useAccountStorage } from "../../../../hooks/useAccountStorage";
import { getDeviceDisplayName } from "../../../../utils/breedingDevices";
import { remoteDeviceRoute } from "../../../../utils/roles";
import { DeviceTypeBadge } from "../../device/DeviceTypeBadge";

type BuildingDevicesListProps = {
  devices: DeviceWithoutLegacyPassword[];
  compact?: boolean;
  /** Action propre à un produit, affichée avant le lien qui l'ouvre. */
  renderAction?: (device: DeviceWithoutLegacyPassword) => React.ReactNode;
  /** Contenu propre à un produit, affiché sous sa ligne. */
  renderDetails?: (device: DeviceWithoutLegacyPassword) => React.ReactNode;
};

export const BuildingDevicesList = ({
  devices,
  compact = false,
  renderAction,
  renderDetails,
}: BuildingDevicesListProps) => {
  const { t } = useTranslation();
  const { getAccountStorage } = useAccountStorage();
  const accountType = getAccountStorage()?.type;

  if (devices.length === 0) {
    return (
      <p className="text-sm text-grey-medium italic py-1">
        {t("building-devices-empty")}
      </p>
    );
  }

  return (
    <ul className={compact ? "space-y-1" : "space-y-2"}>
      {devices.map((device) => {
        const deviceRoute = remoteDeviceRoute(device.uuid, accountType);

        return (
          <li key={device.id} className="space-y-1">
            <div
              className={`flex items-center gap-2 ${
                compact ? "text-sm" : "text-base"
              }`}
            >
              <DeviceTypeBadge type={device.type} />
              <span className="font-oxaniumMedium text-default-text truncate">
                {getDeviceDisplayName(device)}
              </span>
              {renderAction && (
                <span className="ml-auto shrink-0">{renderAction(device)}</span>
              )}
              {deviceRoute && (
                <Link
                  to={deviceRoute}
                  onClick={(event) => event.stopPropagation()}
                  className={`${
                    renderAction ? "" : "ml-auto "
                  }shrink-0 text-secondary hover:text-tertiary transition-colors`}
                  title={t("device-open")}
                >
                  <FontAwesomeIcon icon="eye" />
                </Link>
              )}
            </div>
            {renderDetails?.(device)}
          </li>
        );
      })}
    </ul>
  );
};
